 
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Stack,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Typography,
} from '@mui/material';

const CheckboxStack = function CheckboxStack({
  data = [],
  direction = 'column',
  defaultCheckedAr = [],
  styles = null,
  checkboxProps = null,
  label = null,
  noEmptyValues = false,
  handleChange,
}) {
  const [checkedArray, setCheckedArray] = useState(null);

  useEffect(() => {
    if (checkedArray) handleChange(checkedArray); //changes the value
  }, [checkedArray]);

  const handleChangeChecked = (e) => {
    //add to value position in array the checked value
    const { checked, value } = e.target;
    if (checked) {
      const newRating = checkedArray ? [...checkedArray] : [];
      newRating[value] = value;
      setCheckedArray(newRating);
    } else {
      const newRating = checkedArray ? [...checkedArray] : [];
      newRating[value] = null;
      if (noEmptyValues) {
        if (!newRating?.every((item) => item === null)) {
          setCheckedArray(newRating);
        }
      } else {
        setCheckedArray(newRating);
      }
    }
  };

  useEffect(() => {
    if (!checkedArray && defaultCheckedAr?.length)
      if (
        noEmptyValues &&
        (defaultCheckedAr?.length < 0 ||
          defaultCheckedAr?.every((item) => item === null))
      ) {
        const filledArray = [];
        data.forEach(({ value }) => {
          filledArray[value] = value.toString();
        });
        setCheckedArray(filledArray);
      } else {
        setCheckedArray(defaultCheckedAr);
      }
  }, [defaultCheckedAr]);

  return (
    <Stack sx={styles?.stackStyle}>
      {label && (
        <Typography variant="caption" sx={{ fontSize: '14px' }}>
          {label}
        </Typography>
      )}
      <FormGroup sx={styles?.formGroupStyle} row={direction === 'row'}>
        {data?.map((item) => {
          const isDefaultChecked =
            typeof checkedArray?.find(
              (el) => parseInt(el, 10) === item.value
            ) !== 'undefined'; //if value is finded return the value else undefined

          return (
            <FormControlLabel
              disableTypography={typeof item.label === 'object'} //label needs to be wrapped inside typography if
              disabled={item?.disabled}
              sx={styles?.formControlLabelStyle}
              key={item.value}
              control={
                <Checkbox
                  {...checkboxProps}
                  onChange={handleChangeChecked}
                  value={item.value}
                  checked={isDefaultChecked}
                />
              }
              label={
                typeof item.label === 'object' ? (
                  item.label
                ) : (
                  <Typography
                    variant="caption"
                    sx={{ fontSize: '14px' }}
                    noWrap
                  >
                    {item.label}
                  </Typography>
                )
              }
            />
          );
        })}
      </FormGroup>
    </Stack>
  );
};

CheckboxStack.propTypes = {
  data: PropTypes.array,
  direction: PropTypes.string,
  label: PropTypes.string,
  defaultCheckedAr: PropTypes.array,
  styles: PropTypes.object,
  checkboxProps: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  noEmptyValues: PropTypes.bool,
};

export default CheckboxStack;
